<div class="d-flex container-fluid p-0 apiContainer" id="wrapper">
  <!-- Sidebar-->
  <div class="border-end bg-white" id="sidebar-wrapper">
    <span onclick="openNav()" class="openbtnIAG"><i class="fa fa-bars fa-lg"></i></span>
    <div class="list-group list-group-flush">
      <div id="mySidenav" class="sidenav scrollToContent">
        <div class="nav-header">
          <a href="javascript:void(0)" class="closebtnIAG" onclick="closeNav()">
            <i class="fa fa-bars fa-lg"></i>
          </a>
        </div>
        <div id="sideMenu-header" class="sideMenu-header">
          <a href="/home">
            <img class="sideMenu-logo logo4" [src]="configService.getLogo('BA_LOGO_MOBILE')" />
          </a>
        </div>
        <div class="sidebar-nav">
          <ul class="parent">
            <span class="notSubmenu">
              <a href="/" class="liclass">
                <span class="nav-text"> <i class="fa fa-home fa-smx"></i>NDC Hub</span>
              </a>
            </span>
            <li *ngFor="let category of categories; let i = index" class="parent-menu{{ i }}" [ngClass]="category?.subMenuIconClass ? 'submenu' : ''">
              <a class="liclass" attr.id="{{ i }}" (click)="setPageTitle(category.pageTitle || ''); closeNav(); scrollTotop()">
                <span class="nav-text"> {{ category.title }}</span>
              </a>

              <ul class="parent child">
                <li *ngFor="let link of linkMap.get(category.title); let j = index" class="parent-menu{{ i }}-{{ j }}" [ngClass]="link?.subMenuIconClass ? 'submenu' : ''">
                  <a class="liclass navigateTab" attr.id="{{ i + '-' + j }}" attr.tab="{{ '#' + link.href }}" href="#" (click)="closeNav(); scrollTotop()">
                    <span class="nav-text"> {{ link.title }}</span>
                  </a>
                  <!--(click)="scrollToHref(link.href || ''); closeNav()"-->
                  <a class="trigger-tab dNone" href="#{{ link.href }}"></a>
                  <ul class="parent child">
                    <li *ngFor="let reference of link.references; let k = index" class="parent-menu{{ i }}-{{ j }}-{{ k }}" [ngClass]="reference?.subMenuIconClass ? 'submenu' : ''">
                      <a class="liclass" attr.id="{{ i + '-' + j + '-' + k }}" href="#{{ reference.href }}" (click)="scrollToHref(reference.href || ''); closeNav(); scrollTotop()">
                        <span class="nav-text"> {{ reference.title }}</span>
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="apiContainerRight">
    <app-iag-booking-portals-page *ngIf="pageTitle === 'IAG Booking Portals Support'"></app-iag-booking-portals-page>
    <app-iag-portal-product-update-notifications-page *ngIf="pageTitle === 'IAG Portal Product Update Notifications'"></app-iag-portal-product-update-notifications-page>
    <app-iag-portal-revision-notices  *ngIf="pageTitle && pageTitle.includes('IG-')" [pageTitle]="pageTitle"></app-iag-portal-revision-notices>
    <app-iag-portal-roadmap-page *ngIf="pageTitle === 'IAG Booking Portals Roadmap'"></app-iag-portal-roadmap-page>
    <app-iag-portal-where-do-i-register-page *ngIf="pageTitle === 'Where do I register'"></app-iag-portal-where-do-i-register-page>
    <app-iag-portal-how-do-i-make-a-booking-page *ngIf="pageTitle === 'How do I make a booking'"></app-iag-portal-how-do-i-make-a-booking-page>
    <app-iag-portal-how-do-i-service-a-booking-page *ngIf="pageTitle === 'How do I service a Portal booking'"></app-iag-portal-how-do-i-service-a-booking-page>
    <app-iag-portal-feedback-and-suggestions-page *ngIf="pageTitle === 'Feedback and suggestions'"></app-iag-portal-feedback-and-suggestions-page>
    <app-iag-portal-reports-page *ngIf="pageTitle === 'Reports'"></app-iag-portal-reports-page>
    <app-iag-portal-support-page *ngIf="pageTitle === 'IAG Portal Support'"></app-iag-portal-support-page>
    <app-iag-portal-logging-in-page *ngIf="pageTitle === 'Logging In'"></app-iag-portal-logging-in-page>
    <app-iag-portal-faqs-page *ngIf="pageTitle === 'IAG Booking Portal FAQs'"></app-iag-portal-faqs-page>
    <app-iag-portal-user-management-page *ngIf="pageTitle === 'User management'"></app-iag-portal-user-management-page>
    <app-iag-portal-disrupted-bookings-page *ngIf="pageTitle === 'Disrupted bookings'"></app-iag-portal-disrupted-bookings-page>
    <app-iag-portal-how-does-it-work-page *ngIf="pageTitle === 'How does it work'"></app-iag-portal-how-does-it-work-page>
  </div>
</div>
